import { put } from "redux-saga/effects";
import { ApplicationReportAction } from "../../action";
import { Client } from "../../../../utils/transport";
import dayjs from "dayjs";
import { ExportCSV } from "utils/export-csv";
import { hms } from "utils/timeConverter";
import { SOMETHING_WENT_WRONG } from "constants/staticText.js";
import { getDownloadTableViewColumns } from "utils/commonUtils";
const exportData = (payload, data) => {
  let result = [];
  const fileName = `Application & Url Report`;
  const appUrlType = `Apps/Urls Type : ${payload?.body?.type_name
    ?.replaceAll(",", "/")
    .toUpperCase()}`;
  const date = `Date : ${dayjs(payload?.body?.start_date).format(
    "DD-MM-YYYY"
  )} To ${dayjs(payload?.body?.end_date).format("DD-MM-YYYY")} `;
  // Dynamic columns
  const dynamicFields = payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = [
    ...(payload?.body?.datewise ? ["Date"] : []),
    "Apps/URLS",
    "Type",
    "usage Percent (%)",
    "Total Duration (hh:mm:ss)",
    "Active Duration (hh:mm:ss)",
  ];

  const finalHeaders = [
    ...(payload?.body?.report_group_by === "userwise" ? ["Employee"] : []),
    ...(payload?.body?.report_group_by === "userwise" ? dynamicHeaders : []),
    ...fixedHeaders,
  ];

  const Generated = "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");
  const generatedData = [
    fileName,
    appUrlType,
    date,
    Generated,
    finalHeaders.join(),
  ];
  let mainData = "";
  let sortData = [];
  if (payload?.body?.report_group_by === "userwise") {
    sortData = data.sort((a, b) =>
      (a.first_name || "").localeCompare(b.first_name || "")
    );
  } else {
    sortData = data.sort((a, b) =>
      (a.app_name || "").localeCompare(b.app_name || "")
    );
  }
  sortData.map((record) => {
    const user = payload?.user_map_data?.[record.iden];
    const employeeName =
      !record?.first_name && !record?.last_name
        ? "--"
        : `${record.first_name} ${record.last_name}`;

    const dynamicValues = getDownloadTableViewColumns(
      payload?.viewFields,
      user,
      payload?.team_map_data
    );
    const fixedValues = [
      ...(payload?.body?.datewise
        ? [(record.event_day || "-").split("T")[0]]
        : []),
      record?.app_name?.replace(
        /^(https?:\/\/)|(Https?:\/\/)|(<)|(>)|\/$/g,
        ""
      ),
      record?.type?.toUpperCase(),
      record?.prod_percent,
      hms(record?.productive_duration),
      hms(record?.active_duration),
    ];

    generatedData.push(
      [
        ...(payload?.body?.report_group_by === "userwise"
          ? [employeeName]
          : []),
        ...(payload?.body?.report_group_by === "userwise" ? dynamicValues : []),
        ...fixedValues,
      ].join(",")
    );
  });
  result = generatedData;
  return result;
};
const exportcsv = (payload, data) => {
  const exdata = exportData(payload, data);
  ExportCSV("Application URL Report", exdata);
};

export function* GetApplicationReportGraphData(action) {
  const config = {
    method: "POST",
    url: "query/application/app_url_usage",
    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);

    yield put(
      ApplicationReportAction.ApplicationReportGraphSuccess(response.data?.data)
    );
  } catch (err) {
    yield put(
      ApplicationReportAction.ApplicationReportGraphFailed({
        error: SOMETHING_WENT_WRONG,
      })
    );
  }
}

export function* GetApplicationReportListData(action) {
  const config = {
    method: "POST",
    url: "query/application/app_url_usage",

    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);
    yield put(
      ApplicationReportAction.ApplicationReportListSuccess(response.data)
    );
  } catch (err) {
    yield put(
      ApplicationReportAction.ApplicationReportListFailed({
        error: SOMETHING_WENT_WRONG,
      })
    );
  }
}

export function* getApplicationReportExportListData(action) {
  const config = {
    method: "POST",
    url: "query/application/app_url_usage",

    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
    fetchPolicy: "no-cache",
  };
  try {
    const response = yield Client.request(config);
    const rows = response.data.data;
    const n = Math.floor(
      response.data.optional?.pagination?.total_records /
        action.payload.body.limit
    );
    for (let i = 0; i < n; i++) {
      const config = {
        method: "POST",
        url: `query/application/app_url_usage`,
        headers: {
          ...action.payload.headers,
        },
        data: { ...action.payload.body, page: i + 2 },
      };
      const response = yield Client.request(config);
      rows.push(...response.data.data);
    }
    exportcsv(action.payload, rows);
    yield put(ApplicationReportAction.ApplicationReportExportListSuccess());
  } catch (err) {
    console.log("we have a hit", err);
    yield put(
      ApplicationReportAction.ApplicationReportExportListFailed({
        error: SOMETHING_WENT_WRONG,
      })
    );
  }
}
